<template>
  <helper-layout
    :loaded="mx_loaded"
  >
    <v-layout v-if="tempData" row wrap>
      <v-flex xs12 text-xs-left>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card class="details-wrap">
            <div class="detail-title" :style="`color:${color}`">
              {{ tempData.name }}
            </div>

            <v-flex text-xs-right>
              <v-btn
                :color="$store.state.app.color"
                @click="showConfigRefer"
              >{{ $t('Core.Action.configRefer') }}</v-btn>
            </v-flex>
            <!-- 收件人 -->
            <v-flex xs6>
              <v-text-field
                v-model="tempData.mailTo"
                clearable
                :label="$t('Views.Setting.mailTo')"
                :placeholder="$t('Core.Valid.mailTo')"
                class="input-required"
                required
                :rules="mailToRules"
                :validate-on-blur="true"
              />
            </v-flex>
            <!-- 暗抄送人 -->
            <v-flex xs6>
              <v-text-field
                v-model="tempData.bcc"
                clearable
                :label="$t('Views.Setting.mailBbc')"
                :placeholder="$t('Core.Valid.mailTo')"
                :rules="mailBCCRules"
              />
            </v-flex>
            <!-- 邮件主题 -->
            <v-flex xs6>
              <v-text-field
                v-model="tempData.subject"
                clearable
                :label="$t('Views.Setting.mailSubject')"
                :placeholder="$t('Core.Valid.mailSubject')"
                class="input-required"
                required
                :rules="mailSubjectRules"
                :validate-on-blur="true"
              />
            </v-flex>
            <!-- 邮件正文 -->
            <v-flex xs12>
              <v-textarea
                v-model="tempData.body"
                :placeholder="$t('Core.Valid.mailBody')"
                :label="$t('Views.Setting.mailBody')"
                clearable
                rows="26"
                class="input-required"
                required
                :rules="mailBodyRules"
                :validate-on-blur="true"
              />
            </v-flex>
            <!-- 是否可用 -->
            <v-flex xs6 class="flex-box">
              <div class="label">{{ $t('Core.Action.isVisible') }}:</div>
              <v-checkbox
                v-model="tempData.enabled"
                :color="color"
              />
            </v-flex>
          </v-card>
        </v-form>
      </v-flex>

      <v-flex xs12 text-xs-center class="btn-bottom">
        <v-btn color="cancel" outline @click="goBack">
          {{ $t("Views.Setting.goBack") }}
        </v-btn>
        <v-btn
          v-clickthrottle="{ handle: save, delay: 3000 }"
          :disabled="!canSubmit"
          :color="$store.state.app.color"
        >
          {{ $t("Views.Setting.save") }}
        </v-btn>
      </v-flex>

      <!-- 参数对照弹窗 -->
      <material-dialog
        :width="700"
        :visible="configReferVisible"
        :title="$t('Core.Action.configRefer')"
        :show-close="false"
        @cancleFn="() => configReferVisible = false"
        @confirmFn="() => configReferVisible = false"
      >
        <template>
          <div class="refer-box">
            <div class="refer-th">
              <div class="item">{{ $t("Views.Setting.mailReferKey") }}</div>
              <div class="item">{{ $t("Views.Setting.mailReferValue") }}</div>
            </div>

            <div
              v-for="item in paramsDescriptionKeys"
              :key="item"
              class="refer-item"
            >
              <div class="item">{{ item }}</div>
              <div class="item">{{ tempData.paramsDescription[item] }}</div>
            </div>
          </div>
        </template>
      </material-dialog>
    </v-layout>
  </helper-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { pageLoadMx } from '@/plugins/mixins'
import ENUMS from '@/dict/enums'
export default {
  mixins: [pageLoadMx],
  data() {
    const $t = this.$t.bind(this)
    return {
      configReferVisible: false,
      paramVisible: false,
      valid: true,
      mailToRules: [
        v => !!v || $t('Core.Valid.required'),
        v => !(v && v.length > 256) || $t('Core.Valid.maxLen', { max: 256 })
      ],
      mailBCCRules: [
        v => !(v && v.length > 256) || $t('Core.Valid.maxLen', { max: 256 })
      ],
      mailSubjectRules: [
        v => !!v || $t('Core.Valid.required'),
        v => !(v && v.length > 32) || $t('Core.Valid.maxLen', { max: 32 })
      ],
      mailBodyRules: [
        v => !!v || $t('Core.Valid.required'),
        v => !(v && v.length > 4000) || $t('Core.Valid.maxLen', { max: 4000 })
      ]
    }
  },
  computed: {
    ...mapState('setting', ['tempData']),
    color() {
      return ENUMS.primaryColor[this.$store.state.app.color]
    },
    tempId() {
      return this.$route.query.id
    },
    canSubmit() {
      return this.tempData && (this.tempData.mailTo && this.tempData.subject && this.tempData.body)
    },
    paramsDescriptionKeys() {
      return typeof this.tempData.paramsDescription === 'object' && Object.keys(this.tempData.paramsDescription)
    }
  },
  mounted() {
    this.getPage()
  },
  methods: {
    ...mapActions('setting', [
      'emailTempGather'
    ]),
    getPage(page) {
      if (!this.mx_loaded) this.mx_loading_fn() // 页面加载中
      this.emailTempGather({ type: 'get', id: this.tempId }).then(() => {
        this.mx_loaded_fn() // 页面加载完成
      })
    },
    goBack() {
      this.$router.go(-1)
    },
    save() {
      if (this.$refs.form.validate()) {
        this.emailTempGather({ type: 'put', ...this.tempData }).then(() => {
          const vm = this
          this.$store.commit('app/setNotification', {
            msg: vm.$t('Views.Setting.actionSuccess'),
            type: 'success'
          })

          this.goBack()
        })
      }
    },
    showConfigRefer() {
      this.configReferVisible = true
    }
  }
}
</script>

<style scoped lang="styl">
.flex-box {
  display: flex;
  align-items: flex-start;

  /deep/ .v-input {
    margin-top: 0;
    margin-left: 10px;
  }

  .label {
    margin-top: 8px;
    font-size: 14px;
    font-weight: 700;
    color: #515151;
  }
}
.refer-box {
  width: 100%;
  min-height: 500px;
  font-size: 12px;
  border-top: 1px solid #e8eaec;
  /* border-right: 1px solid #e8eaec; */

  .refer-th {
    background: #f8f8f9;
  }

  .item {
    display: inline-block;
    box-sizing: border-box;
    width: 50%;
    padding: 10px 8px;
    border-bottom: 1px solid #e8eaec;
    border-left: 1px solid #e8eaec;

    &:last-child {
      border-right: 1px solid #e8eaec;
    }
  }
}
</style>
